import React from 'react'

export default function ScrollDown() {
  return (
   <div className="home__scroll">
    <div className='home__scroll1 lines1'></div>
    <div className='home__scroll2 lines2'></div>
   </div>
  )
}
